import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import RegisterHeader from '../../../components/headers/register-header';
import {Column, Row} from '../../../components/layout';
import {
  addToGlobalStyles,
  addToWizard,
  setSelectedBu,
  setStringsDefault,
  setWizard,
  setStrings,
  setLanguage,
  setGlobalStyles,
} from '../../../store/actions';
import colors, {pageBackgrounds} from '../../../util/colors';
import * as fonts from '../../../util/fonts';
import './styles.scss';
import {
  uriGetBuStylesFromBuAlias,
  uriSendActivationCode,
} from '../../../api/endpoints';
import {strings} from '../../../util/strings';
import {useHistory} from 'react-router-dom';
import {createGUID, updateStringFeatureWithLabels} from '../../../util/utility';
import {get, post} from '../../../api/api';
import * as Yup from 'yup';
import {
  AppForm,
  AppFormField,
  AppFormSubmitButton,
} from '../../../components/forms';
import AppErrorMessage from '../../../components/app-error-message';
import AppSpinner from '../../../components/app-spinner';
import {ITenant} from '../../../App';

export interface ForgetPasswordProps {
  wizard: any;
  language: any;
  addToWizard(value: any): void;
  addToGlobalStyles(value: any): void;
  labels: typeof strings.pt.login;
  labelsProfile: typeof strings.pt.myProfile;
  messageLabels: typeof strings.pt.messages;
  setSelectedBu(value: any): void;
  reduxStrings: any;
  setStringsDefault(value: any): void;
  setStrings(value: any): void;
  setLanguage(value: any): void;
  setGlobalStyles: Function;
  tenant: ITenant;
  globalStyles: any;
  stringsDefault: any;
}

function ForgetPassword({
  labels,
  labelsProfile,
  messageLabels,
  reduxStrings,
  addToGlobalStyles,
  setStringsDefault,
  setLanguage,
  setGlobalStyles,
  tenant,
  globalStyles,
  language,
  stringsDefault,
}: ForgetPasswordProps) {
  const [notExistingEmail, setNotExistingEmail] = useState(false);
  const [hasErrorMessage, setHasErrorMessage] = useState(false);
  const [email, setEmail] = useState('');
  const history = useHistory();
  const sessionGuid = createGUID();
  const [valid, setValid] = useState(false);
  const [hoverErrorIcon, setHoverErrorIcon] = useState(false);
  const [loading, setLoading] = useState(true);

  const featureName = 'ForgotPassword';

  const defineOnMouseFunctions = (e: React.MouseEvent) => {
    var elem: HTMLElement = e.target as HTMLElement;
    var icon: HTMLElement = elem.nextSibling as HTMLElement;
    if (icon) {
      icon.onmouseover = function () {
        setHoverErrorIcon(true);
      };
      icon.onmouseout = function () {
        setHoverErrorIcon(false);
      };
    }
  };

  const handleEmail = (value: string) => setEmail(value);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required(messageLabels.requiredField)
      .email(messageLabels.invalidEmail),
  });

  useEffect(() => {
    const languageFromLogin = history.location.search?.split('=')[1];

    languageFromLogin && setLanguage(languageFromLogin);
  }, []);

  useEffect(() => {
    setLoading(!!!stringsDefault);
  }, [stringsDefault]);

  useEffect(() => {
    tenant?.alias && getDefaultBuStyles();
  }, [tenant?.alias]);

  const getDefaultBuStyles = async () => {
    const busStyles = (await get(
      uriGetBuStylesFromBuAlias(tenant?.buDefaultAlias || 'ADV'),
      false,
      0,
      featureName
    )) as any;
    setGlobalStyles({
      ...busStyles?.data?.items?.[0],
      background: pageBackgrounds.forgotPasswordPage,
    });
  };

  if (hasErrorMessage) {
    return (
      <Row className="justify-content-center">
        <Column className="forgot-password-maincolumn">
          <RegisterHeader />
          <Row className="forgot-password-titlerow">
            <p
              className="forget-passoword-title"
              style={{
                ...fonts.L,
                color: colors.red,
                fontWeight: 'bold',
              }}>
              {reduxStrings?.services?.services_error}
            </p>
          </Row>
        </Column>
      </Row>
    );
  }

  return notExistingEmail ? (
    <> {history.push('/deseja-registar')} </>
  ) : (
    <Row className="justify-content-center">
      <Column className="forgot-password-maincolumn">
        <RegisterHeader />
        <AppForm
          validationSchema={validationSchema}
          initialValues={{email}}
          onChange={handleEmail}
          onSubmit={async (values: any) => {
            setLoading(true);
            await post(
              uriSendActivationCode(),
              JSON.stringify({
                destination: values.email,
                sessionGuid: sessionGuid,
                buId: null,
              }),
              false,
              featureName
            )
              .then((res: any) => {
                history.push('/alterar-password', {
                  email: values.email,
                  sessionGuid: sessionGuid,
                  contactEmail: values.email,
                });
              })
              .catch((err: any) => {
                console.log('err', err);
                if (err.status === 500) {
                  setHasErrorMessage(true);
                } else {
                  setNotExistingEmail(true);
                }
              })
              .finally(() => {
                setLoading(false);
              });
          }}>
          {!loading && (
            <>
              <Row className="forgot-password-titlerow">
                <p
                  className="forget-passoword-title"
                  style={{
                    ...fonts.XL,
                    color: colors.black,
                    fontWeight: 'bold',
                  }}>
                  {labels?.login_forgotPassword}
                </p>
              </Row>
              <Row className="forgot-password-row-send-email">
                <p
                  style={{
                    ...fonts.M,
                    color: colors.black,
                  }}>
                  {labels?.login_forgotPassword_mailNotification}
                </p>
              </Row>
              <Row
                className="forgot-password-row-input justify-content-center"
                style={{position: 'relative'}}>
                <AppFormField
                  showErrorMessage
                  name="email"
                  placeholder={labelsProfile?.profile_registration_email}
                  className="forgot-password-email-input"
                  onMouseOver={(e) => defineOnMouseFunctions(e)}></AppFormField>
              </Row>
              <Row className="justify-content-center">
                <a
                  className="forgot-password-anchor"
                  style={{
                    ...fonts.M,
                    color: globalStyles?.primaryColor,
                  }}
                  onClick={() => history.push('/recuperar-email')}>
                  {labels?.login_forgotPassword_dontRememberEmail}
                </a>
              </Row>
              <Row className="justify-content-center">
                <AppFormSubmitButton
                  title={labels?.login_forgotPassword_continuar}
                  className="forgot-password-button"></AppFormSubmitButton>
              </Row>{' '}
            </>
          )}
          {loading && <AppSpinner type="grey" />}
        </AppForm>
      </Column>
    </Row>
  );
}

const mapStateToProps = ({
  wizard,
  stringsDefault,
  language,
  tenant,
  globalStyles,
}: any) => ({
  wizard: wizard.value,
  language: language.value,
  labels: stringsDefault.value.pt.login,
  labelsProfile: stringsDefault.value.pt.myProfile,
  messageLabels: stringsDefault.value.pt.messages,
  reduxStrings: stringsDefault.value,
  tenant: tenant.value,
  globalStyles: globalStyles.value,
  stringsDefault: stringsDefault.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  setSelectedBu: (value: any) => dispatch(setSelectedBu(value)),
  setStringsDefault: (value: any) => dispatch(setStringsDefault(value)),
  setStrings: (value: any) => dispatch(setStrings(value)),
  setLanguage: (value: any) => dispatch(setLanguage(value)),
  setGlobalStyles: (value: any) => dispatch(setGlobalStyles(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(ForgetPassword)
);
